import React from "react";

const BathSvg = () => {
  return (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.04759 3.00847C7.2845 2.65158 8.57654 3.36498 8.93343 4.60189C9.02912 4.93354 8.83784 5.27996 8.50619 5.37566C8.20218 5.46337 7.88575 5.30996 7.76142 5.02832L7.73242 4.94842C7.56692 4.3748 6.96774 4.04397 6.39412 4.20948C6.07396 4.30185 5.81666 4.53581 5.69268 4.84025L5.65258 4.95759L5.62459 5.05552V8.99892H17.2521C17.7635 8.99892 18.178 9.41347 18.178 9.92485C18.178 9.97246 18.1743 10.02 18.167 10.0671L17.2814 15.7648C17.1727 16.464 16.6817 17.0209 16.0413 17.2361V17.7489C16.0413 18.0941 15.7614 18.3739 15.4163 18.3739C15.0998 18.3739 14.8384 18.1388 14.797 17.8337L14.7913 17.7489V17.3323H5.20807V17.7489C5.20807 18.0941 4.92824 18.3739 4.58307 18.3739C4.26665 18.3739 4.00516 18.1388 3.96377 17.8337L3.95807 17.7489V17.2361C3.31767 17.0209 2.82669 16.464 2.71802 15.7648L1.83241 10.0671C1.75387 9.56175 2.09983 9.08845 2.60514 9.00991C2.65219 9.0026 2.69973 8.99892 2.74735 8.99892H4.37459V7.74889H3.95793C3.61275 7.74889 3.33293 7.46907 3.33293 7.12389C3.33293 6.77871 3.61275 6.49889 3.95793 6.49889H4.37459V4.97232L4.39759 4.80436L4.44856 4.62165C4.6658 3.84304 5.27092 3.23257 6.04759 3.00847ZM3.1256 10.2489H16.8731L16.0463 15.5728L16.0266 15.6583C15.9498 15.907 15.7186 16.0822 15.4516 16.0822H4.54794L4.46042 16.0758C4.20282 16.0382 3.99424 15.8366 3.95323 15.5728L3.1256 10.2489Z"
          fill="#118BF4"
        ></path>
      </svg>
    </span>
  );
};

export default BathSvg;
